import { render } from "./LaunchProjectBox.vue?vue&type=template&id=96cb35f8"
import script from "./LaunchProjectBox.vue?vue&type=script&lang=js"
export * from "./LaunchProjectBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__